import { plural } from '@cian/utils';
import { NBSP } from '../../../constants/symbols';

export const getHousesCount = (count: number | undefined): string | undefined => {
  return count ? count + NBSP + plural(count, ['дом', 'дома', 'домов']) : undefined;
};
